import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    coins: JSON.parse(localStorage.getItem('coins')) || {},
    addresses: JSON.parse(localStorage.getItem('addresses')) || []
}

export const coinSlice = createSlice({
    name: 'coins',
    initialState,
    reducers: {
        setCoins: (state, action) =>{
            state.coins = action.payload;  
            localStorage.setItem('coins', JSON.stringify(state.coins));
        },
        setAddresses: (state, action) =>{
            state.addresses = action.payload;  
            localStorage.setItem('addresses', JSON.stringify(state.addresses));
        }
    }
})

export const {setCoins, setAddresses} = coinSlice.actions;
export default coinSlice.reducer;